import { Divider, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';

import Flex from '@Components/Bases/Flex';
import FormCheckbox from '@Components/Form/FormCheckBox';
import { formatToShortThaiDateTime } from '@Utils/datetime';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';

type ICompleteSectionFormProps = {
  label?: string;
  checkSectionName: string;
  enableCheckSectionTh: boolean;
  enableCheckSectionEn: boolean;
  onCompleteThChange?: (checked?: boolean) => void;
  onCompleteEnChange?: (checked?: boolean) => void;
  roleStampTh?: string;
  roleStampEn?: string;
  formattedCompletedSectionDateTh?: string;
  formattedCompletedSectionDateEn?: string;
};

export const confirmLabel = 'ยืนยันการตรวจสอบข้อมูลครบถ้วน';

const CompleteSectionForm = (props: ICompleteSectionFormProps) => {
  const {
    label = confirmLabel,
    checkSectionName,
    enableCheckSectionTh,
    enableCheckSectionEn,
    onCompleteThChange,
    onCompleteEnChange,
  } = props;

  const completedSection = useWatch({
    name: checkSectionName,
  }) as CompleteSectionFormValues | undefined;

  const {
    isCompletedTh = false,
    isCompletedEn = false,
    dateTh,
    dateEn,
    roleStampTh,
    roleStampEn,
  } = completedSection || {};

  const formattedDateTh = dateTh ? formatToShortThaiDateTime(dateTh) : '';
  const formattedDateEn = dateEn ? formatToShortThaiDateTime(dateEn) : '';

  const isSectionNameComplete = checkSectionName === 'completedSection';

  return (
    <>
      <Divider sx={{ mt: 3 }} />
      <Flex
        gap={4}
        justifyContent={'center'}
        bgcolor={'grey.50'}
        py={1}
        width={1}
      >
        <Flex alignItems={'center'}>
          <Typography fontWeight="bold" textAlign={'right'}>
            {label}
          </Typography>
        </Flex>
        <Flex>
          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              name={`${checkSectionName}.isCompletedTh`}
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาไทย)"
              rules={{ required: 'กรุณากรอกข้อมูลให้ครบถ้วน' }}
              inputProps={{
                disabled: !enableCheckSectionTh,
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onCompleteThChange?.(e.target.checked)
              }
            />
            {isCompletedTh && dateTh && !isSectionNameComplete && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampTh} {formattedDateTh}
              </Typography>
            )}
          </Flex>
          <Flex flexDirection="column" alignItems={'center'}>
            <FormCheckbox
              sx={{ ml: 2 }}
              name={`${checkSectionName}.isCompletedEn`}
              label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาอังกฤษ)"
              rules={{ required: 'กรุณากรอกข้อมูลให้ครบถ้วน' }}
              inputProps={{
                disabled: !enableCheckSectionEn,
              }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onCompleteEnChange?.(e.target.checked)
              }
            />
            {isCompletedEn && dateEn && !isSectionNameComplete && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ display: 'block' }}
              >
                โดย {roleStampEn} {formattedDateEn}
              </Typography>
            )}
          </Flex>
        </Flex>
      </Flex>
    </>
  );
};

export default CompleteSectionForm;
